import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faCheckCircle, faExclamationTriangle, faXmarkCircle, } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SecondaryButton from '~/components/buttons/SecondaryButton';
import Modal from '~/components/modals/Modal';
import useAlert from '~/hooks/useAlert';
const getAlertIcon = (status) => {
    if (status === 'success') {
        return (_jsx(FontAwesomeIcon, { className: "text-green-500", icon: faCheckCircle, size: "3x" }));
    }
    if (status === 'warning') {
        return (_jsx(FontAwesomeIcon, { className: "text-yellow-500", icon: faExclamationTriangle, size: "3x" }));
    }
    if (status === 'error') {
        return (_jsx(FontAwesomeIcon, { className: "text-red-500", icon: faXmarkCircle, size: "3x" }));
    }
};
const AlertModal = () => {
    const { text, type, setAlert } = useAlert();
    let statusTextStyle;
    let statusTitle;
    let statusMessage;
    if (!type) {
        return _jsx(_Fragment, {});
    }
    switch (type) {
        case 'warning':
            statusTextStyle = 'text-yellow-500';
            statusTitle = 'WARNING';
            statusMessage = 'This action was successful, but with warnings.';
            break;
        case 'error':
            statusTextStyle = 'text-red-500';
            statusTitle = 'ERROR';
            statusMessage = 'Something went wrong. Please try again.';
            break;
        case 'success':
        default:
            statusTextStyle = 'text-green-500';
            statusTitle = 'SUCCESS';
            statusMessage = 'This action was successful.';
            break;
    }
    return (_jsx(Modal, { styles: "w-60 p-4", children: _jsxs("div", { className: "flex flex-col justify-between p-5", children: [_jsxs("div", { className: `flex flex-col items-center ${statusTextStyle} `, children: [_jsx("div", { className: "mb-2", children: getAlertIcon(type) }), _jsx("div", { className: "mt-2 text-2xl font-semibold tracking-wide", children: statusTitle })] }), _jsx("div", { className: "mt-8 flex justify-center text-center text-lg text-slate-500", children: text || statusMessage }), _jsx("div", { className: "mt-14 flex justify-center gap-4", children: _jsx(SecondaryButton, { onClick: () => setAlert(), text: "Dismiss" }) })] }) }));
};
export default AlertModal;
